import { Action } from 'redux';

import { DeleteRemoteExtractRefresh } from '../../../bootstrap/redux/actions/AppActionTypes';
import { IRemoteRefreshScheduleInfo } from '../../models/IRemoteRefreshScheduleInfo';

export interface DeleteRemoteExtractRefreshAction extends Action {
  schedules: IRemoteRefreshScheduleInfo[];
}

export function deleteRemoteExtractRefresh(
  schedules: IRemoteRefreshScheduleInfo[]
): DeleteRemoteExtractRefreshAction {
  return {
    type: DeleteRemoteExtractRefresh,
    schedules,
  };
}
